import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'SolBlox | Flip. Spin. Win.',
  description = 'Explore the #1 solana based coinflipping site. Secure and transparent. Get Started Now!',
  keywords = 'SolBlox, Solana gaming, SOL gambling, blockchain games, coinflip, jackpot, provably fair, crypto gaming, Solana casino, SOL betting',
  image = '/logo.png',
  url = 'https://solblox.com',
  type = 'website'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="SolBlox" />
      <meta property="og:image:width" content="400" />
      <meta property="og:image:height" content="400" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />
    </Helmet>
  );
};

export default SEO;